/**
 * BgParticles
 * 背景パーティクル（particles.js 本家）。顧客提供のJSON設定（/assets/json/particlesjs-config.json）を読み込んで描画する。
 * particles.js本体は libs.js（非module＝非strict）で読込済み（ESバンドルに入れると strict mode で deepExtend が壊れるため）。
 * 設定パスはコンテナの data-particles-config で指定（MTでは get_template_directory_uri 付きで出力）。
 *
 * particles.js は コンテナ（id付き div）内に <canvas class="particles-js-canvas-el"> を生成する。
 * 受け皿（全画面・最背面 .l-bg ／ 背景の透過）は従来どおり流用。
 *
 * @usage HTML: <div id="particles-js" class="l-bg js-bg-particles" data-particles-config="/assets/json/particlesjs-config.json"></div>
 *        JS:   new BgParticles();
 */
export default class BgParticles {
  constructor(options = {}) {
    this.element = document.querySelector(options.selector || '.js-bg-particles');
    this.configPath = options.configPath
      || (this.element && this.element.dataset.particlesConfig)
      || '/assets/json/particlesjs-config.json';

    if (this.element && this.element.id && window.particlesJS) {
      this.init();
    }
  }

  init() {
    try {
      window.particlesJS.load(this.element.id, this.configPath, () => {});
    } catch (error) {
      console.error('BgParticles: Failed to load particles.js config', error);
    }
  }
}
